import { render, staticRenderFns } from "./_ChannelGroupPreview.vue?vue&type=template&id=a7301d10&scoped=true&"
import script from "./_ChannelGroupPreview.vue?vue&type=script&lang=ts&"
export * from "./_ChannelGroupPreview.vue?vue&type=script&lang=ts&"
import style0 from "./_ChannelGroupPreview.vue?vue&type=style&index=0&id=a7301d10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7301d10",
  null
  
)

export default component.exports